import React from 'react';
import { Box, Typography } from '@mui/material';
import InboxIcon from '@mui/icons-material/Inbox';
import { PageActionButton } from '../PageShell';

const ProspectsEmptyState = ({ title, description, actionLabel, onAction }) => (
  <Box display='flex' flexDirection='column' alignItems='center' textAlign='center' gap={1} sx={{ py: 8, px: 2 }}>
    <InboxIcon color='disabled' />
    <Typography variant='body1' fontWeight='bold'>
      {title}
    </Typography>
    <Typography variant='body2' color='text.secondary' sx={{ maxWidth: 460 }}>
      {description}
    </Typography>
    {actionLabel ? (
      <Box mt={1.5}>
        <PageActionButton onClick={onAction}>{actionLabel}</PageActionButton>
      </Box>
    ) : null}
  </Box>
);

export default ProspectsEmptyState;
